/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./mhpTreatmentConsultationQuestionIds";

export const mhpConsultationMasterConfig: MasterQuestionConfig[] = [
    // Completed on Behalf of
    {
        id: questionIds.CompletedOnBehalfOf,
        questionText: "Completed on behalf of",
        canBeDisabled: false
    },
    {
        id: questionIds.CompletedOnBehalfOfName,
        questionText: "",
        canBeDisabled: false
    },
    {
        id: questionIds.CompletedOnBehalfOfTitle,
        questionText: "",
        canBeDisabled: false
    },
    {
        id: questionIds.CompletedOnBehalfOfQualification,
        questionText: "",
        canBeDisabled: false
    },
    // Completed by
    {
        id: questionIds.CompletedBy,
        questionText: "",
        canBeDisabled: false
    },
    {
        id: questionIds.CompletedByName,
        questionText: "",
        canBeDisabled: false
    },
    {
        id: questionIds.CompletedByTitle,
        questionText: "",
        canBeDisabled: false
    },
    {
        id: questionIds.CompletedByQualification,
        questionText: "",
        canBeDisabled: false
    },

    // Introduction and Data Privacy
    {
        id: questionIds.IntroductionAndDataPrivacyConfirmOtherIdentifier,
        questionText: "If you are unable to match the DOB with address/postcode, use another identifier",
        canBeDisabled: false
    },
    {
        id: questionIds.IntroductionAndDataPrivacyConfirmOtherIdentifierDetails,
        questionText: "How was identity confirmed",
        canBeDisabled: false
    },
    {
        id: questionIds.IntroductionAndDataPrivacyConsultationMethod,
        questionText: "Consultation Method",
        canBeDisabled: false
    },
    {
        id: questionIds.IntroductionAndDataPrivacyRecordingConsent,
        questionText: "I need to inform you that Telephone calls at Optima Health "
            + "are recorded for training and monitoring purposes. Recordings are only held for a period "
            + "of 130 days after which time they are fully deleted. You can request a copy of the "
            + "recording or request for it to be deleted by writing to us at our registered address "
            + "which can be found on our website. Can you confirm if you are happy to proceed?",
        canBeDisabled: false
    },
    {
        id: questionIds.IntroductionAndDataPrivacyProceedConsent,
        questionText: "This is our XXX treatment session today and I will be writing confidential notes " +
            "throughout the session. Can you confirm that you're happy to proceed?",
        canBeDisabled: false
    },

    // Questionnaires and Risk
    {
        id: questionIds.PsychologicalWellbeingPHQ9Score,
        questionText: "PHQ9 Score (These comments will be added to your report)",
        canBeDisabled: false
    },
    {
        id: questionIds.PsychologicalWellbeingPHQ9Outcome,
        questionText: "PHQ9 Outcome",
        canBeDisabled: false
    },
    {
        id: questionIds.PsychologicalWellbeingGAD7Score,
        questionText: "GAD7 Score (These comments will be added to your report)",
        canBeDisabled: false
    },
    {
        id: questionIds.PsychologicalWellbeingGAD7Outcome,
        questionText: "GAD7 Outcome",
        canBeDisabled: false
    },
    {
        id: questionIds.PsychologicalWellbeingWSASScore,
        questionText: "WSAS Score (These comments will be added to your report)",
        canBeDisabled: false
    },
    {
        id: questionIds.PsychologicalWellbeingWSASOutcome,
        questionText: "WSAS Outcome",
        canBeDisabled: false
    },
    {
        id: questionIds.RiskAssessmentCompleted,
        questionText: "Risk Assessment Completed",
        canBeDisabled: false
    },
    {
        id: questionIds.RiskAssessmentCompletedToSelf,
        questionText: "To self",
        canBeDisabled: false
    },
    {
        id: questionIds.RiskAssessmentCompletedToOthers,
        questionText: "To others",
        canBeDisabled: false
    },
    {
        id: questionIds.RiskAssessmentCompletedSafeguardingIssues,
        questionText: "Safeguarding issues",
        canBeDisabled: false
    },
    {
        id: questionIds.RiskAssessmentCompletedFactorsAddingToRisk,
        questionText: "Factors adding to risk",
        canBeDisabled: false
    },
    {
        id: questionIds.RiskManagementPlan,
        questionText: "Risk Management Plan",
        canBeDisabled: false
    },

    // IAPT Questionnaire
    {
        id: questionIds.IaptEmployeeName,
        questionText: "Employee Name",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptJobRole,
        questionText: "Job Role",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptCarryOutIaptAssessment,
        questionText: "",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptCarryOutPhq9Assessment,
        questionText: "Do you want to carry out a PHQ9?",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptCarryOutGad7Assessment,
        questionText: "Do you want to carry out a GAD7?",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptCarryOutWsasAssessment,
        questionText: "Do you want to carry out a WSAS?",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptLittleInterestOrPleasureInDoingThings,
        questionText: "Little interest or pleasure in doing things",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptFeelingDownDepressedOrHopeless,
        questionText: "Feeling down, depressed, or hopeless",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptTroubleFallingOrStayingAsleepOrSleepingTooMuch,
        questionText: "Trouble falling or staying asleep, or sleeping too much",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptFeelingTiredOrHavingLittleEnergy,
        questionText: "Feeling tired or having little energy",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptPoorAppetiteOrOvereating,
        questionText: "Poor appetite or overeating",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptFeelingBadAboutYourself,
        questionText: "Feeling bad about yourself - or that you are a failure or have let yourself or your family down",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptTroubleConcentratingOnReadingOrWatching,
        questionText: "Trouble concentrating on things, such as reading the newspaper or watching television",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptMovingOrSpeakingSoSlowly,
        questionText: "Moving or speaking so slowly that other people could have noticed? Or the opposite - being so fidgety or restless that you have been moving around a lot more than usual",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptThoughtsThatWouldBeBetterOffDeadOrOfHurtingYourself,
        questionText: "Thoughts that you would be better off dead or of hurting yourself in some way",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptPsychologicalWellbeingPHQ9Score,
        questionText: "PHQ9 Score (These comments will be added to your report)",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptFeelingNervousAnxiousOrOnEdge,
        questionText: "Feeling nervous, anxious or on edge",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptNotBeingAbleToStopOrControlWorrying,
        questionText: "Not being able to stop or control worrying",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptWorryingTooMuchAboutDifferentThings,
        questionText: "Worrying too much about different things",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptTroubleRelaxing,
        questionText: "Trouble relaxing",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptBeingSoRestlessThatItIsHardToSitStill,
        questionText: "Being so restless that it is hard to sit still",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptBecomingEasilyAnnoyedOrIrritable,
        questionText: "Becoming easily annoyed or irritable",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptFeelingAfraidAsIfSomethingAwfulMightHappen,
        questionText: "Feeling afraid as if something awful might happen",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptPsychologicalWellbeingGAD7Score,
        questionText: "GAD7 Score (These comments will be added to your report)",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptWork,
        questionText: "WORK",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptHomeManagement,
        questionText: "HOME MANAGEMENT - Cleaning, tidying, shopping, cooking, looking after home/ children, paying bills etc.",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptSocialLeisureActivities,
        questionText: "SOCIAL LEISURE ACTIVITIES - With other people, e.g., Parties, pubs, outings, entertaining etc.",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptPrivateLeisureActivities,
        questionText: "PRIVATE LEISURE ACTIVITIES - Done alone, e.g., Reading, gardening, sewing, hobbies, walking etc.",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptFamilyAndRelationships,
        questionText: "FAMILY AND RELATIONSHIPS - Form and maintain close relationships with others including the people that I live with",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptPsychologicalWellbeingWSASScore,
        questionText: "WSAS Score (These comments will be added to your report)",
        canBeDisabled: false
    },

    // Clinical Notes
    {
        id: questionIds.ClinicalNotesRiskLetterToGeneralPractitioner,
        questionText: "Risk Letter to GP?",
        canBeDisabled: false
    },
    {
        id: questionIds.ClinicalNotesComments,
        questionText: "Clinical Notes",
        canBeDisabled: false
    },

    // Standard Clinical Details and Outcome
    {
        id: questionIds.ClinicalDetailsCurrentWorkStatus,
        questionText: "Current Work Status",
        canBeDisabled: false
    },
    {
        id: questionIds.ClinicalDetailsProvisionalDiagnosis,
        questionText: "Provisional Diagnosis (This will be pulled through to the Diagnosis section of the report)",
        canBeDisabled: false
    },
    {
        id: questionIds.ClinicalDetailsCoMorbidConditions,
        questionText: "Co-morbid conditions (This will be pulled through to the Diagnosis section of the report)",
        canBeDisabled: false
    },
    {
        id: questionIds.ClinicalDetailsCoMorbidConditionsOther,
        questionText: "Co-morbid conditions - other comments (This will be pulled through to the Diagnosis section of the report)",
        canBeDisabled: false
    },
    {
        id: questionIds.ClinicalDetailsTreatmentCompletedInTodaysSession,
        questionText: "Treatment completed in today's session",
        canBeDisabled: false
    },
    {
        id: questionIds.ClinicalDetailsTreatmentCompletedInTodaysSessionOther,
        questionText: "Treatment completed in today's session - other comments",
        canBeDisabled: false
    },
    {
        id: questionIds.ClinicalDetailsSessionsSignpostingDischarge,
        questionText: "Continuing sessions / signposting / discharge",
        canBeDisabled: false
    },
    {
        id: questionIds.ClinicalDetailsSignpostToOtherServices,
        questionText: "Signpost to Other Services",
        canBeDisabled: false
    },
    {
        id: questionIds.ClinicalDetailsSignpostToOtherServicesOther,
        questionText: "Signpost to Other Services - other comments",
        canBeDisabled: false
    },
    {
        id: questionIds.ClinicalDetailsOutcomeFinalSessionOnly,
        questionText: "Outcome (final session only) (This will be pulled through to the Outcome section of the report)",
        canBeDisabled: false
    },
    {
        id: questionIds.ClinicalDetailsOnwardReferral,
        questionText: "Onward referral (counselling/IAPT services etc) (This will be pulled through to the Outcome section of the report)",
        canBeDisabled: false
    },

    // Consent and Report
    {
        id: questionIds.ConsentAndReportConsent,
        questionText: "If this is the first or last session: Following on from our treatment I will send a report to your "
            + "line manager to explain that we have completed treatment. It will contain basic information about the treatment "
            + "we've completed and your questionnaire scores at the beginning and end of treatment and any further "
            + "recommendations to support you and your employer. Do you consent for me to generate this report and send it to you and your manager / HR?",
        canBeDisabled: false
    },
    {
        id: questionIds.ConsentAndReportScopeOfReport,
        questionText: "Consent for release of Report",
        canBeDisabled: false
    },
    {
        id: questionIds.ConsentAndReportAlternativeConsentChoice,
        questionText: "Details of Alternative Consent choice",
        canBeDisabled: false
    },
    {
        id: questionIds.EmployeeEmailAddress,
        questionText: "Employee Email Address",
        canBeDisabled: false
    },
    {
        id: questionIds.ManagerEmailAddress,
        questionText: "Manager Email Address",
        canBeDisabled: false
    },
    {
        id: questionIds.HREmailAddress,
        questionText: "HR Email Address",
        canBeDisabled: false
    },
];
